import SeatsScreenController from '../../../containers/seats/SeatsScreenController';
import Constants from '../../../model/AppConfiguration';

export default { toggleRoutes };

function toggleRoutes (ignoreTrip) {
  if (!ignoreTrip && this.state.selectedTrip.id === Constants.flights.oneWay) {
    return;
  }
  let selectedRoute = this.state.selectedRoute;
  let routes = this.props.routes;
  let flights = this.state.flights || this.props.flights;
  let changeActivePassenger =
    this.props.actions && this.props.actions.changeActivePassenger ?
      this.props.actions.changeActivePassenger :
      () => {};
  for (let i = 0; i < routes.length; i++) {
    let route = routes[ i ];
    if (selectedRoute.id === route.id) {
      if (i === routes.length - 1) {
        this.setState({ selectedRoute: routes[ 0 ] });
        updateActivePassengerOnRouteChange(flights, routes[ 0 ].id, changeActivePassenger);
        return;
      }
      let nextRoute = routes[ i + 1 ];
      if (nextRoute) {
        this.setState({ selectedRoute: nextRoute });
        updateActivePassengerOnRouteChange(flights, nextRoute.id, changeActivePassenger);
      }
    }
  }
}

function updateActivePassengerOnRouteChange (flights, routeId, changeActivePassenger) {
  let flight = flights.find(flight => flight.routeId === routeId);
  if (flight) changeActivePassenger(SeatsScreenController.changePassenger(flight.passengers));
}



// WEBPACK FOOTER //
// ./src/components/flights/routesSwitch/RoutesSwitchController.js